// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2otea","content":"RecentSearches_content__1UFF8"};